import type { PartnerRiskStatus } from '@erp/shared';
import { useTranslation } from 'react-i18next';
import { Badge, type BadgeVariant } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const RISK_VARIANTS: Record<PartnerRiskStatus, BadgeVariant> = {
  NORMAL: 'outline',
  WATCHLIST: 'warning',
  DELIVERY_LOCK: 'warning',
  SALES_LOCK: 'danger',
  COLLECTION: 'danger',
  INSOLVENCY: 'danger',
};

/** Warnsymbole der Liste; sie machen die Eskalationsstufe auf einen Blick erkennbar. */
const RISK_SIGNS: Record<PartnerRiskStatus, string> = {
  NORMAL: '',
  WATCHLIST: '👁',
  DELIVERY_LOCK: '⚠️',
  SALES_LOCK: '⚠️',
  COLLECTION: '⚠️',
  INSOLVENCY: '🚨',
};

export interface PartnerRiskBadgeProps {
  riskStatus: PartnerRiskStatus;
  isBlocked: boolean;
  className?: string;
}

export function PartnerRiskBadge({
  riskStatus,
  isBlocked,
  className,
}: PartnerRiskBadgeProps): JSX.Element | null {
  const { t } = useTranslation();

  if (riskStatus === 'NORMAL' && !isBlocked) {
    return null;
  }

  const sign = RISK_SIGNS[riskStatus];

  return (
    <Badge
      variant={RISK_VARIANTS[riskStatus]}
      className={cn('whitespace-nowrap font-semibold uppercase tracking-wide', className)}
    >
      {sign === '' ? null : (
        <span aria-hidden="true" className="mr-1">
          {sign}
        </span>
      )}
      {t(`partners.riskStatuses.${riskStatus}`)}
    </Badge>
  );
}
